
const FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER = Object.freeze({
  FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER_PANEL: [
    {
      id: 0,
      panelTitle: '2023-24',
      subPanel: [
        {
          subId: 0,
          subPanelTitle: 'Q1 - 2023-24',
          subPanelLink: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/newspaper-publication-Q1FY23-24.pdf',
        },
        {
          subId: 1,
          subPanelTitle: 'Q2 - 2023-24',
          subPanelLink: 'https://cdn.zaggle.in/images/web/zaggle/pdf/investor-relations/disclosures-regulation/newspaper-publication-Q2FY23-24.pdf',
        },
      ],
    },
  ],
});

export {
  FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/FinancialResultsPublishedNewsPaper/constants.js